// Centralised rolling J-5 promo banner mechanism.
// Targets containers marked with [data-apple-promo-rolling] and fills child
// spans [data-apple-promo-title], [data-apple-promo-subtitle],
// [data-apple-promo-countdown] with phase-aware copy and an HH:MM:SS countdown.
//
// Phase A (04h-23h59) : "Du J-5 au J : aujourd'hui dernier jour. Promo se
//                      termine à minuit." + countdown until 00:00.
// Phase B (00h-03h59) : "Mise à jour des prix en cours. Les prix promo restent
//                      valables. La promo se termine à 4h du matin." + countdown
//                      until 04:00.
// Phase C (04h00 trigger) : auto re-render Phase A (handled by setInterval).
//
// Pure client-side computation. No localStorage. No external deps. defer-loaded.
(function () {
  'use strict';

  function formatDateFR(date) {
    return date.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long'
    });
  }

  function getCurrentPhase() {
    return new Date().getHours() >= 4 ? 'A' : 'B';
  }

  function getCountdownTarget() {
    var now = new Date();
    var target = new Date(now);
    if (getCurrentPhase() === 'A') {
      target.setHours(24, 0, 0, 0); // next midnight
    } else {
      target.setHours(4, 0, 0, 0); // today 04:00
    }
    return target;
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatCountdown(targetMs) {
    var diff = Math.max(0, targetMs - Date.now());
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function buildCopy() {
    var phase = getCurrentPhase();
    var now = new Date();
    var start = new Date(now.getTime() - 5 * 86400000);
    if (phase === 'A') {
      return {
        title: 'Du ' + formatDateFR(start) + ' au ' + formatDateFR(now) + ' : aujourd\u2019hui dernier jour.',
        subtitle: 'Promo se termine \u00e0 minuit.'
      };
    }
    return {
      title: 'Mise \u00e0 jour des prix en cours. Les prix promo restent valables.',
      subtitle: 'La promo se termine \u00e0 4h du matin.'
    };
  }

  function render() {
    var copy = buildCopy();
    var targetMs = getCountdownTarget().getTime();
    var countdownStr = formatCountdown(targetMs);
    var nodes = document.querySelectorAll('[data-apple-promo-rolling]');
    nodes.forEach(function (el) {
      var titleEl = el.querySelector('[data-apple-promo-title]');
      var subtitleEl = el.querySelector('[data-apple-promo-subtitle]');
      var countdownEl = el.querySelector('[data-apple-promo-countdown]');
      if (titleEl) titleEl.textContent = copy.title;
      if (subtitleEl) subtitleEl.textContent = copy.subtitle;
      if (countdownEl) countdownEl.textContent = countdownStr;
    });
  }

  function boot() {
    render();
    setInterval(render, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
